<script>
import {mapGetters} from "vuex";
import {Bar} from 'vue-chartjs/src/BaseCharts'
import {reactiveProp} from 'vue-chartjs/src/mixins'
import zoom from 'chartjs-plugin-zoom';

const showZeroPlugin = {
  beforeRender: function (chartInstance) {
    let datasets = chartInstance.config.data.datasets;

    for (let i = 0; i < datasets.length; i++) {
      let meta = datasets[i]._meta;
      let metaData = meta[Object.keys(meta)[0]];
      let bars = metaData.data;

      for (let j = 0; j < bars.length; j++) {
        let model = bars[j]._model;

        if (metaData.type === "horizontalBar" && model.base === model.x) {
          model.x = model.base + 2;
        }
        if (model.base === model.y) {
          model.y = model.base - 2;
        }
        if ((model.base - model.y) < 3) {
          model.y = model.base - 3;
        }
      }
    }
  }
};

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    goal_currency: {
      type: Object
    },
    chartData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    chartOptions() {
      return {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              display: false,
              padding: 25,
            },
            gridLines: {
              color: '#F0F4F7',
              zeroLineColor: '#F0F4F7',
              drawTicks: false
            },
          }],
          xAxes: [{
            stacked: true,
            // type: 'time',
            // time: {
            //   parser: 'MM.YYYY',
            //   // round: 'day'
            //   unit: 'month',
            //   // tooltipFormat: 'll HH:mm'
            // },
            ticks: {
              fontColor: '#8A9BA5',
            },
            gridLines: {
              zeroLineColor: '#F0F4F7',
              color: '#F0F4F7',
            },
          }]
        },
        datasets: {
          bar: {
            categoryPercentage: 0.95
          }
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
          enabled: false,
          custom: (tooltipModel) => {
            // Tooltip Element
            const chart_tooltip_id = 'chartjs-tooltip-' + this.$data._chart.canvas.id;
            let tooltipEl = document.getElementById(chart_tooltip_id);
            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = chart_tooltip_id;
              tooltipEl.classList.add('chartjs-tooltip');
              tooltipEl.innerHTML = "<table></table>"
              this.$data._chart.canvas.parentElement.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            // Set Text
            if (tooltipModel.body) {
              let titleLines = tooltipModel.title || [];
              let bodyLines = tooltipModel.body.map(getBody);

              let innerHtml = '<thead>';

              titleLines.forEach(function (title) {
                innerHtml += '<tr><th>' + title + '</th></tr>';
              });
              innerHtml += '</thead><tbody>';

              bodyLines.forEach((body, i) => {
                let colors = tooltipModel.labelColors[i],
                    style = 'background:' + colors.backgroundColor;
                style += '; border-color:' + colors.borderColor;
                style += '; border-width: 1px';
                let span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>',
                    label = body[0].split(':')[0],
                    value = body[0].split(':')[1];
                innerHtml += `<tr><td>${span}${label}: ${this.displayCurrencyValue(+value, this.goal_currency)}</td></tr>`;
              });
              innerHtml += '</tbody>';

              let tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }

            let positionY = this.$data._chart.canvas.offsetTop;
            let positionX = this.$data._chart.canvas.offsetLeft;

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = positionX + tooltipModel.caretX + 'px';
            tooltipEl.style.top = positionY + tooltipModel.caretY - tooltipModel.height * 1.5 + 'px';
            tooltipEl.style.fontSize = '12px';
            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
          }
        },
        responsive: true,
        scaleShowLabels: false,
        maintainAspectRatio: false,
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'x'
            },
            zoom: {
              enabled: true,
              mode: 'x',

              // rangeMin: {
              //   x: this.chartData.labels[0],
              // },
              // rangeMax: {
              //   x: this.chartData.labels[this.chartData.labels.length - 1],
              // },
            }
          }
        }
      }
    }
  },
  mounted() {
    this.addPlugin(zoom);
    // this.addPlugin(customPlugin);
    this.addPlugin(showZeroPlugin);
    this.renderChart(this.chartData, this.chartOptions);
  }
}
</script>

<style>
.chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, .7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  white-space: nowrap;
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
</style>